export default [
  {
    path: '/gourmet/',
    name: 'gourmet',
    title: 'gourmet',
    component: () => import('../views/GourmetView.vue'),
    redirect: { name: 'licencaDroid' },
    children: [
      {
        path: 'licencaDroid',
        name: 'licencaDroid',
        component: () => import('../views/LicencaDroidWelcomeView.vue'),
        meta: {
          title: 'Licença gourmet droid',
        },
      },
    ],
  },
];
